import { stringify } from 'qs';
import { request } from '@/utils/request';

export async function checkUrlPermission (params) {
  return request(`/user/privileges/isResourcePermit?${stringify(params)}`);
}

// 页面权限
export async function checkPagePermission (params) {
  return request(`/api/workbench/privileges/page_elements?${stringify(params)}`);
}

// 异常信息提示
export async function checkExceptionRecord (params) {
  return request('/api/zlbuser/exception/record/exceptionRecord/notice', { params });
}

// 获取登陆人信息
export const getOperatorInfo = async () => {
  return request('/api/user/current/operator/displayInfo');
};
